import { render, staticRenderFns } from "./PacingEffect.vue?vue&type=template&id=0fb8e329&scoped=true&"
import script from "./PacingEffect.vue?vue&type=script&lang=js&"
export * from "./PacingEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb8e329",
  null
  
)

export default component.exports